import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';


@Injectable()
export class SpinnerService {
   // private spinnerObserver: Observer<boolean>;
    public spinnerObservable: EventEmitter<boolean>;

    constructor() {

        this.spinnerObservable = new EventEmitter<boolean>();
    }

    show() {
       this.spinnerObservable.emit(true);
    }

    hide() {
         this.spinnerObservable.emit(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinner.service.ts